export const getCheckeredBg = () => {
  return `bg-[conic-gradient(#f0f0f0_90deg,_#e0e0e0_90deg_180deg,_#f0f0f0_180deg_270deg,_#e0e0e0_270deg)] bg-[length:20px_20px]`;
};
